import { head, values } from 'lodash'

const OPERATIONS = {
  yes: 'in',
  no: '!in',
}

export const OPTIONS = {
  all: {
    value: 'all',
    label: 'All Students',
    Operation: 'in',
    Values: [],
  },
  yes: {
    value: 'yes',
    label: 'First Generation Students',
    Operation: OPERATIONS.yes,
    Values: [true],
    getMatch: (value, operation) => head(value) === true && operation === OPERATIONS.yes,
  },
  no: {
    value: 'no',
    label: 'Non-First Generation Students',
    Operation: OPERATIONS.no,
    Values: [true],
    getMatch: (value, operation) => head(value) === true && operation === OPERATIONS.no,
  },
}

export const getAppropriateOption = (value, operation) => {
  if (OPTIONS.yes.getMatch(value, operation)) {
    return OPTIONS.yes.value
  }
  if (OPTIONS.no.getMatch(value, operation)) {
    return OPTIONS.no.value
  }
  return OPTIONS.all.value
}

export const OPTIONS_ARRAY = values(OPTIONS)
